import React from 'react';

import { BodySmallText, FontEmphasis } from '@prisjakt/ui/text/variants';
import RatingComponent from 'src/components/rating';
import { StoreLogoVariant } from 'src/components/store-logo';
import { Price } from '../price';
import { ProductName } from '../product-name';

import {
  Content,
  PriceWrapper,
  Properties,
  ShopLogo,
  StyledPrice,
} from './styles';

import { CdnImage } from 'src/components/cdn-image';
import type { BaseProps, ProductProperty } from '../../types';
import { useIsKWLP } from 'src/areas/keyword-landing-page/contexts';

type Props = Pick<
  BaseProps,
  | 'category'
  | 'diffPercentage'
  | 'highlightedName'
  | 'name'
  | 'price'
  | 'properties'
  | 'rank'
  | 'rating'
  | 'reviewsCount'
  | 'store'
>;

export const GridCardContent: React.FC<Props> = props => {
  const {
    category,
    diffPercentage,
    highlightedName,
    name,
    price,
    properties,
    rank,
    rating,
    reviewsCount,
    store,
  } = props;

  const isKWLP = useIsKWLP();
  const coreProperties = mapToCoreProperties(properties);

  return (
    <Content>
      <ProductName>{highlightedName || name}</ProductName>

      {category?.name && !rank && (
        <BodySmallText emphasis={FontEmphasis.MEDIUM}>
          {category.name}
        </BodySmallText>
      )}
      {typeof coreProperties === 'string' && (
        <Properties>
          <BodySmallText emphasis={FontEmphasis.MEDIUM}>
            {coreProperties}
          </BodySmallText>
        </Properties>
      )}

      {rating && rating > 0 ? (
        <RatingComponent
          rate={rating}
          count={reviewsCount}
          showCounterAs="number"
        />
      ) : null}

      {price != null && (
        <PriceWrapper gap={0.5} isKWLP={isKWLP}>
          <StyledPrice>
            <Price
              price={price}
              isDeal={Boolean(diffPercentage)}
              currency={store?.currency}
            />
          </StyledPrice>

          {store &&
            (isKWLP ? (
              <CdnImage
                name={(store && store.id) || ''}
                alt={(store && store.name) || ''}
                height={22}
              />
            ) : (
              <ShopLogo
                variant={StoreLogoVariant.CAMPAIGN}
                name={store.name}
                storeId={store.id}
                featured
                hasImage={store.hasLogo || false}
              />
            ))}
        </PriceWrapper>
      )}
    </Content>
  );
};

function mapToCoreProperties(properties: ProductProperty[] | null | undefined) {
  return Array.isArray(properties)
    ? properties
        .filter(({ isCore, pretty }) => isCore && pretty !== null)
        .map(({ pretty }) => pretty)
        .join(', ')
    : null;
}
